import { Selectable } from '@hakimo-ui/shared/ui-base';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useSOPAlarmTypes(locationId: string, enabled = true) {
  const url = `/v2/orm/sop/alarm-types?location_id=${locationId}`;
  const request = new Request(url);

  return useAuthenticatedRequest<Selectable[]>(request, {
    queryKey: ['sop-alarm-types', locationId],
    enabled: enabled && !!locationId,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useSOPAlarmTypes;
